export default "__VITE_ASSET__D9D5D38$__"